import { I18nFragment } from '@diagentech/exprworks-ui-components';
import Typography from '@mui/material/Typography';
import React from 'react';

import { useAppSelector } from '@/App/hooks';
import { getYearDifference } from '@/components/layout/AppFooter/getYearDifference';
import { selectAppConfig } from '@/features/config/selectAppConfig';

export const Copyright: React.FC = () => {
  const { foundationYear } = useAppSelector(selectAppConfig);

  return (
    <Typography
      variant="body2"
      color="textSecondary"
      sx={{
        textAlign: 'right',
      }}
    >
      <I18nFragment id="SH.FTR.COPYRIGHT" args={[getYearDifference(foundationYear)]} />
    </Typography>
  );
};
